import { logger } from "@sentry/react"
import { AllSectionsProps } from "../UI/Cards/Interfaces/DashboardContainer"
import { AccountantDashboard, AdminDashboard, CEODashboard, ITDashboard, ManagerDashboard } from "../UI/Section/RoleDashboards"

/**
 * This is a factory function that returns the top portion of the dashboard based on the role. IE The Projects, Tasks, etc.
 * @param role - The role Hierarchy of the user
 * @param props - The props to pass to the container
 * @returns The correct container based on the role
 */
export function DashboardFactory(role: string, props: AllSectionsProps) {
    switch (role) {
        case "FINANCE":
            return <AccountantDashboard {...props} />
        case "ADMIN":
            return <AdminDashboard {...props} />
        case "CEO":
            return <CEODashboard {...props} />
        case "IT":
            return <ITDashboard {...props} />
        case "MANAGERS":
            return <ManagerDashboard {...props} />
        default:
            logger.error(`Role ${role} not found in DashboardFactory`)  // This should never happen
            return <ManagerDashboard {...props} />
    }
}